<template lang="html">
    <div class="side-chat-head">
        <div class="remote-user-profile">
            <div class="remote-user-image">
                <img :src="otherUser.image_url" alt="" v-if="otherUser.role == 'specialist'">
                <img src="@/assets/images/person-icon.png" alt="" v-else>

                <i class="remote-user-status fas fa-circle" :class="{online: this.remoteUserOnline}"></i>
            </div>
            <div class="remote-user-info">
                <div class="remote-user-name">
                    {{otherUser.full_name}}
                </div>
                <div class="remote-user-title" v-if="otherUser.role == 'specialist' || true">{{otherUser.title}}</div>
            </div>
        </div>
        <div class="remote-user-devices" v-if="this.remoteUserHasDevices">
             <i class="fas" :class="{'fa-microphone': this.remoteUserMicStatus, 'fa-microphone-slash': !this.remoteUserMicStatus, 'off': !this.remoteUserMicStatus}" v-if="this.remoteUserHasMic"></i>
             <i class="fas" :class="{'fa-video': this.remoteUserVideoStatus, 'fa-video-slash': !this.remoteUserVideoStatus, 'off': !this.remoteUserVideoStatus}" v-if="this.remoteUserHasVideo"></i>
        </div>
        <div class="remote-user-devices" v-else>
            <i class="fas fa-comment" :class="{'off':!this.remoteUserOnline}"></i> <i class="fas fa-eye" :class="{'off':!this.remoteUserOnline}"></i>
        </div>
    </div>
</template>

<script>

  import { mapGetters } from 'vuex'
export default {
  props: {
    remoteUser: {
      type: Object,
      default: function() {
        return {
          "online": false,
        };
      }
    }
  },
  computed: {
    ...mapGetters({
      otherUser: 'meeting/otherUser'
    }),

    remoteUserOnline() {
      if(this.remoteUser != null && this.remoteUser.online === true)
        return true;
      return false;
    },
    remoteUserHasDevices(){
      if(this.remoteUserHasMic || this.remoteUserHasVideo)
        return true;
      return false;
    },
    remoteUserHasMic(){
      if(this.remoteUser.microphone != null)
        return true;
      return false;
    },
    remoteUserMicStatus(){
      if(this.remoteUser.microphone != null && this.remoteUser.microphone == true)
        return true;
      return false;
    },
    remoteUserHasVideo(){
      if(this.remoteUser.video != null)
        return true;
      return false;
    },
    remoteUserVideoStatus(){
      if(this.remoteUser.video != null && this.remoteUser.video == true)
        return true;
      return false;
    }
  },
}
</script>
